import { alphabetEnumerate } from '@/lib/utils';
import { type Node as PMNode } from '@tiptap/pm/model';

export type ResourceCounterGroup = 'question' | 'code_editor' | 'zystudio' | 'figure' | 'table' | 'inline_enum';
export type ResourceOrdinal = number | string;

export function resourceCounterGroup(node: PMNode): ResourceCounterGroup | null {
    const nodeType = node.type.name;
    const nodeSubtype = typeof node.attrs?.type === 'string' ? node.attrs.type : null;

    if (nodeType === 'zyExample' && nodeSubtype === 'figure') {
        return 'figure';
    }

    if (nodeType === 'zyExample' && nodeSubtype === 'table') {
        return 'table';
    }

    if (nodeType === 'zyStudio') {
        return 'zystudio';
    }

    if (nodeType === 'zyDE') {
        return 'code_editor';
    }

    if (nodeType === 'zyGdocDrawing' || nodeType === 'zyFigure') {
        return 'figure';
    }

    if (nodeType === 'table' || nodeType === 'zyTable') {
        return 'table';
    }

    if (nodeType === 'zyInlineEnum') {
        return 'inline_enum';
    }

    if (
        nodeType === 'zyExample' ||
        nodeType === 'zyAnimator' ||
        nodeType === 'zyYoutubeVideo' ||
        nodeType === 'questionSet' ||
        nodeType === 'zyTool' ||
        nodeType === 'zyMathWorksLearningTool' ||
        nodeType === 'zyExercise' ||
        nodeType === 'zyAside' ||
        nodeType === 'zyExplore' ||
        nodeType === 'progressionBuilder' ||
        nodeType === 'blockOrderingBuilder' ||
        nodeType === 'codeWritingBuilder' ||
        nodeType === 'parsonsCodingBuilder' ||
        nodeType === 'openStaxPythonCodeRunnerBuilder'
    ) {
        return 'question';
    }

    return null;
}

export function buildResourceNumberLookup(doc: PMNode): Record<string, ResourceOrdinal> {
    const resourceNumberById: Record<string, ResourceOrdinal> = {};
    const counters: Record<ResourceCounterGroup, number> = {
        question: 1,
        code_editor: 1,
        zystudio: 1,
        figure: 1,
        table: 1,
        inline_enum: 1,
    };

    const walk = (node: PMNode, depth: number) => {
        const nodeId = node.attrs?.id;
        const group = resourceCounterGroup(node);

        if (typeof nodeId === 'string' && nodeId !== '' && group) {
            if (group === 'inline_enum') {
                resourceNumberById[nodeId] = alphabetEnumerate(counters[group] - 1);
                counters[group] += 1;
            } else if (depth === 0) {
                resourceNumberById[nodeId] = counters[group];
                counters[group] += 1;
            }
        }

        node.forEach(child => {
            walk(child, depth + 1);
        });
    };

    doc.forEach(node => {
        walk(node, 0);
    });

    return resourceNumberById;
}
